import { render } from "./ExplainerItem.vue?vue&type=template&id=22a66b48"
import script from "./ExplainerItem.vue?vue&type=script&lang=js"
export * from "./ExplainerItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__